<template>
    <div>
    <!-- 详情 --> 
    <a-drawer
            width="550px"
            :height="340"
            :visible="detailVisible"
            placement="right"
            :footer="false"
            @cancel="handleCancel"
            unmountOnClose
    >
        <template #title>
            <div style="font-weight:bold">{{ detail.sku }}</div>
        </template>
        <a-spin :loading="loading" tip="Loading...">
            <div>
                 <!-- 基础信息 -->
                 <a-divider orientation="left" style="font-weight:600"><icon-star /> {{ $t('base.moreInfo') }}</a-divider>
                <div class="detailItemParent">
                    <div class="detailItem_left">
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('order.erpLineNo')" /></span> 
                            <span class="fieldValue">{{detail.erp_line_no}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('order.brandName')" /></span> 
                            <span class="fieldValue">{{detail.brand_name}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('order.partName')" /></span> 
                            <span class="fieldValue">{{detail.part_name}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('order.torque')" /></span> 
                            <span class="fieldValue">{{detail.torque}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('order.unitCode')" /></span> 
                            <span class="fieldValue">{{detail.unit_code}}</span> 
                        </div>
                        <div class="detailItem">
                            <span class="fieldName"><a-badge status="processing" :text="$t('order.backStatus')" /></span> 
                            <span class="fieldValue">{{detail.back_status}}</span> 
                        </div>
                    </div>
                    <div class="detailItem_right">
                        
                    </div>
                </div>
            </div>
        </a-spin>
    </a-drawer>
    </div>
</template>

<script setup>
    import { nextTick, onMounted, reactive, ref, watch, toRefs, h } from 'vue';
    import { StockOutApi } from '@/api/StockOutApi.js';
    import { OrderApi } from '@/api/OrderApi.js';
    import { Message, Modal } from '@arco-design/web-vue';
    import Table from '@/components/Table.vue';
    import { dateToTimestamp, timestampToDate, getNowDate } from '@/utils/index.js';
    import { useI18n } from 'vue-i18n';


    const props = defineProps({
        row:{
            type:Object,
            default:()=>{}
        },
        detailVisible:{
            type:Boolean,
            default:false,
        },
    })

    const emits = defineEmits(['handleCancel'])

    const { t } = useI18n()

    const loading = ref(true)
    const title = ref('')
    const detail = ref({})

    const init = ()=>{
        title.value = t('base.moreInfo')
        
        for(let key in props.row){
            props.row[key] = props.row[key] == '' || props.row[key] == undefined? '-' : props.row[key]
        }
        console.log(props.row,'rowData')
        detail.value = props.row
        loading.value = false
    }

    const handleCancel = ()=>{
        emits('handleCancel')
    }


    watch(()=>props.detailVisible,async (val)=>{
        init()
    })

    onMounted(()=>{
        
    })
</script>

<style lang="less" scoped>
.detailItem{
    padding-left: 30px;
    line-height: 30px;
    white-space: nowrap;
    
    .fieldName{
        display: inline-block;
        width: 190px;
        color: #333;
    }
    .fieldValue{
        display: inline-block;
        color: #888;
        vertical-align: -webkit-baseline-middle;
    }
}

.detailItemParent{
    display: flex;
    width: 100%;
    padding: 5px 0 20px;
    .detailItem_left,
    .detailItem_right{
        display: flex;
        flex: 1;
        flex-direction: column;
        padding-right: 100px;
    }
}

/deep/ .arco-divider-text{
    font-weight: bold;
}
</style>